import styled from 'styled-components'

import { boostersFontCss } from '@root/entities/premium/ui'
import { CountMax3DigitsFormatted } from '@root/shared/core/format'
import { BoosterIcon } from '@root/shared/ui-kit'

type Props = {
  boosters: number
}

export const PremiumPurchaseBoostersBadge: React.FC<Props> = ({ boosters }) => {
  return (
    <Root>
      <Plus>+</Plus>
      <BoosterIcon color="var(--boostButton-9)" size={8} />
      <Count>
        <CountMax3DigitsFormatted count={boosters} />
      </Count>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 10px;
  background: var(--backgroundA-2);
  height: 18px;
  padding-inline: 6px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 0;
`

const Plus = styled.div`
  ${boostersFontCss}

  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  padding-bottom: 1px;
  letter-spacing: -0.1px;
`

const Count = styled.div`
  ${boostersFontCss}

  font-size: 10px;
  font-weight: 800;
  line-height: 10px;
  letter-spacing: -0.1px;
`
